import { Injectable } from '@angular/core';
import { IMyLocales, IMyOptions } from '../interfaces/public-api';

import { DEFAULT_LOCALE } from '../constants/constants';

@Injectable()
export class DatepickerLocaleService {
    private locales: IMyLocales = {
        'EN_US': {
            dayLabels: { su: 'Sun', mo: 'Mon', tu: 'Tue', we: 'Wed', th: 'Thu', fr: 'Fri', sa: 'Sat' },
            monthLabels: {
                1: 'Jan',
                2: 'Feb',
                3: 'Mar',
                4: 'Apr',
                5: 'May',
                6: 'Jun',
                7: 'Jul',
                8: 'Aug',
                9: 'Sep',
                10: 'Oct',
                11: 'Nov',
                12: 'Dec'
            },
            dateFormat: 'MM/dd/yyyy',
            returnFormat: 'MM/dd/yyyy',
            firstDayOfWeek: 'mo',
            sunHighlight: false,
            yearTxt: '',
            timeBtnText: 'Select Time',
            dateBtnText: 'Select Date',
            commitBtnText: 'OK',
            weekText: 'Week',
            placeholder: 'Please select a date',
            range: {
                begin: 'Please select a begin date',
                end: 'Please select an end date'
            },
            message: {
                101: 'The end time must not be earlier than the start time.',
                102: 'Only ${0} dates are allowed to be selected.'
            },
            dynamicLocale: {
                setting: 'Dynamic Date',
                today: 'Today',
                presentWeek: 'Current Week',
                presentMonth: 'Current Month',
                presentYear: 'Current Year',
                previous: 'Previous',
                future: 'Future',
                day: 'Day',
                month: 'Month',
                year: 'Year',
                week: 'Week',
                current: 'Current',
                first: 'First Day',
                last: 'Last Day'
            },
            multiDatesLocale: {
                backtotoday: 'Back to Today',
                clearSelections: 'Clear All',
                delete: 'Delete',
                selected: 'Selected,Days'
            }
        },
        'ZH_CN': {
            dayLabels: { su: 'æ¥', mo: 'ä¸', tu: 'äº', we: 'ä¸', th: 'å', fr: 'äº', sa: 'å­' },
            monthLabels: {
                1: 'ä¸æ',
                2: 'äºæ',
                3: 'ä¸æ',
                4: 'åæ',
                5: 'äºæ',
                6: 'å­æ',
                7: 'ä¸æ',
                8: 'å«æ',
                9: 'ä¹æ',
                10: 'åæ',
                11: 'åä¸æ',
                12: 'åäºæ'
            },
            dateFormat: 'yyyy-MM-dd',
            returnFormat: 'yyyy-MM-dd',
            firstDayOfWeek: 'mo',
            sunHighlight: false,
            yearTxt: 'å¹´',
            timeBtnText: 'éæ©æ¶é´',
            dateBtnText: 'éæ©æ¥æ',
            commitBtnText: 'ç¡®è®¤',
            weekText: 'å¨',
            placeholder: 'è¯·éæ©æ¥æ',
            range: {
                begin: 'è¯·éæ©å¼å§æ¥æ',
                end: 'è¯·éæ©ç»ææ¥æ'
            },
            message: {
                101: 'ç»ææ¶é´ä¸å¾æ©äºå¼å§æ¶é´ï¼',
                102: 'ä»åè®¸éæ© ${0} ä¸ªæ¥æ'
            },
            dynamicLocale: {
                setting: 'è®¾ç½®å¨ææ¥æ',
                today: 'ä»å¤©',
                presentWeek: 'æ¬å¨',
                presentMonth: 'æ¬æ',
                presentYear: 'ä»å¹´',
                previous: 'è¿å»',
                future: 'æªæ¥',
                day: 'å¤©',
                month: 'æ',
                year: 'å¹´',
                week: 'å¨',
                current: 'æ¬',
                first: 'ç¬¬ 1 å¤©',
                last: 'æå 1 å¤©'
            },
            multiDatesLocale: {
                backtotoday: 'åå°ä»å¤©',
                clearSelections: 'æ¸ç©º',
                delete: 'å é¤',
                selected: 'å·²é,å¤©'
            }
        },
        'ZH_CHT': {
            dayLabels: { su: 'æ¥', mo: 'ä¸', tu: 'äº', we: 'ä¸', th: 'å', fr: 'äº', sa: 'å­' },
            monthLabels: {
                1: 'ä¸æ',
                2: 'äºæ',
                3: 'ä¸æ',
                4: 'åæ',
                5: 'äºæ',
                6: 'å­æ',
                7: 'ä¸æ',
                8: 'å«æ',
                9: 'ä¹æ',
                10: 'åæ',
                11: 'åä¸æ',
                12: 'åäºæ'
            },
            dateFormat: 'yyyy-MM-dd',
            returnFormat: 'yyyy-MM-dd',
            firstDayOfWeek: 'mo',
            sunHighlight: false,
            yearTxt: 'å¹´',
            timeBtnText: 'é¸ææé',
            dateBtnText: 'é¸ææ¥æ',
            commitBtnText: 'ç¢ºèª',
            weekText: 'å¨',
            placeholder: 'è«é¸ææ¥æ',
            range: {
                begin: 'è«é¸æéå§æ¥æ',
                end: 'è«é¸æçµææ¥æ'
            },
            message: {
                101: 'çµææéä¸å¾æ©äºéå§æéï¼',
                102: 'ååè¨±é¸æ ${0} åæ¥æ'
            },
            dynamicLocale: {
                setting: 'è¨­ç½®åææ¥æ',
                today: 'ä»å¤©',
                presentWeek: 'æ¬å¨',
                presentMonth: 'æ¬æ',
                presentYear: 'ä»å¹´',
                previous: 'éå»',
                future: 'æªä¾',
                day: 'å¤©',
                month: 'æ',
                year: 'å¹´',
                week: 'å¨',
                current: 'æ¬',
                first: 'ç¬¬ 1 å¤©',
                last: 'æå¾ 1 å¤©'
            },
            multiDatesLocale: {
                backtotoday: 'åå°ä»å¤©',
                clearSelections: 'æ¸ç©º',
                delete: 'åªé¤',
                selected: 'å·²é¸,å¤©'
            }
        } // ,
        // he: {
        //     dayLabels: { su: '×¨×', mo: '×©× ', tu: '×©×', we: '×¨×', th: '××', fr: '×©×', sa: '×©×' },
        //     monthLabels: {
        //         1: '×× ×',
        //         2: '×¤××¨',
        //         3: '××¨×¥',
        //         4: '××¤×¨',
        //         5: '×××',
        //         6: '××× ',
        //         7: '×××',
        //         8: '×××',
        //         9: '×¡×¤×',
        //         10: '×××§',
        //         11: '× ××',
        //         12: '××¦×'
        //     },
        //     dateFormat: 'dd/mm/yyyy',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // ja: {
        //     dayLabels: { su: 'æ¥', mo: 'æ', tu: 'ç«', we: 'æ°´', th: 'æ¨', fr: 'é', sa: 'å' },
        //     monthLabels: {
        //         1: 'ï¼æ',
        //         2: 'ï¼æ',
        //         3: 'ï¼æ',
        //         4: 'ï¼æ',
        //         5: 'ï¼æ',
        //         6: 'ï¼æ',
        //         7: 'ï¼æ',
        //         8: 'ï¼æ',
        //         9: 'ï¼æ',
        //         10: 'ï¼ï¼æ',
        //         11: 'ï¼ï¼æ',
        //         12: 'ï¼ï¼æ'
        //     },
        //     dateFormat: 'yyyy.mm.dd',
        //     sunHighlight: false
        // },
        // fr: {
        //     dayLabels: { su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'FÃ©v',
        //         3: 'Mar',
        //         4: 'Avr',
        //         5: 'Mai',
        //         6: 'Juin',
        //         7: 'Juil',
        //         8: 'AoÃ»',
        //         9: 'Sep',
        //         10: 'Oct',
        //         11: 'Nov',
        //         12: 'DÃ©c'
        //     },
        //     dateFormat: 'dd/mm/yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // 'fr-ch': {
        //     dayLabels: { su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'FÃ©v',
        //         3: 'Mar',
        //         4: 'Avr',
        //         5: 'Mai',
        //         6: 'Juin',
        //         7: 'Juil',
        //         8: 'AoÃ»',
        //         9: 'Sep',
        //         10: 'Oct',
        //         11: 'Nov',
        //         12: 'DÃ©c'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // fi: {
        //     dayLabels: { su: 'Su', mo: 'Ma', tu: 'Ti', we: 'Ke', th: 'To', fr: 'Pe', sa: 'La' },
        //     monthLabels: {
        //         1: 'Tam',
        //         2: 'Hel',
        //         3: 'Maa',
        //         4: 'Huh',
        //         5: 'Tou',
        //         6: 'Kes',
        //         7: 'Hei',
        //         8: 'Elo',
        //         9: 'Syy',
        //         10: 'Lok',
        //         11: 'Mar',
        //         12: 'Jou'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // es: {
        //     dayLabels: { su: 'Do', mo: 'Lu', tu: 'Ma', we: 'Mi', th: 'Ju', fr: 'Vi', sa: 'Sa' },
        //     monthLabels: {
        //         1: 'Ene',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Abr',
        //         5: 'May',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Ago',
        //         9: 'Sep',
        //         10: 'Oct',
        //         11: 'Nov',
        //         12: 'Dic'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // hu: {
        //     dayLabels: { su: 'Vas', mo: 'HÃ©t', tu: 'Kedd', we: 'Sze', th: 'CsÃ¼', fr: 'PÃ©n', sa: 'Szo' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'MÃ¡r',
        //         4: 'Ãpr',
        //         5: 'MÃ¡j',
        //         6: 'JÃºn',
        //         7: 'JÃºl',
        //         8: 'Aug',
        //         9: 'Szep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // sv: {
        //     dayLabels: { su: 'SÃ¶n', mo: 'MÃ¥n', tu: 'Tis', we: 'Ons', th: 'Tor', fr: 'Fre', sa: 'LÃ¶r' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Maj',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // nl: {
        //     dayLabels: { su: 'Zon', mo: 'Maa', tu: 'Din', we: 'Woe', th: 'Don', fr: 'Vri', sa: 'Zat' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Mei',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'dd-mm-yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // ru: {
        //     dayLabels: { su: 'ÐÑ', mo: 'ÐÐ½', tu: 'ÐÑ', we: 'Ð¡Ñ', th: 'Ð§Ñ', fr: 'ÐÑ', sa: 'Ð¡Ð±' },
        //     monthLabels: {
        //         1: 'Ð¯Ð½Ð²',
        //         2: 'Ð¤ÐµÐ²',
        //         3: 'ÐÐ°ÑÑ',
        //         4: 'ÐÐ¿Ñ',
        //         5: 'ÐÐ°Ð¹',
        //         6: 'ÐÑÐ½Ñ',
        //         7: 'ÐÑÐ»Ñ',
        //         8: 'ÐÐ²Ð³',
        //         9: 'Ð¡ÐµÐ½Ñ',
        //         10: 'ÐÐºÑ',
        //         11: 'ÐÐ¾Ñ',
        //         12: 'ÐÐµÐº'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // uk: {
        //     dayLabels: { su: 'ÐÐ´', mo: 'ÐÐ½', tu: 'ÐÑ', we: 'Ð¡Ñ', th: 'Ð§Ñ', fr: 'ÐÑ', sa: 'Ð¡Ð±' },
        //     monthLabels: {
        //         1: 'Ð¡ÑÑ',
        //         2: 'ÐÑÑ',
        //         3: 'ÐÐµÑ',
        //         4: 'ÐÐ²Ñ',
        //         5: 'Ð¢ÑÐ°',
        //         6: 'Ð§ÐµÑ',
        //         7: 'ÐÐ¸Ð¿',
        //         8: 'Ð¡ÐµÑ',
        //         9: 'ÐÐµÑ',
        //         10: 'ÐÐ¾Ð²',
        //         11: 'ÐÐ¸Ñ',
        //         12: 'ÐÑÑ'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // no: {
        //     dayLabels: { su: 'SÃ¸n', mo: 'Man', tu: 'Tir', we: 'Ons', th: 'Tor', fr: 'Fre', sa: 'LÃ¸r' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Mai',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Des'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // tr: {
        //     dayLabels: { su: 'Paz', mo: 'Pzt', tu: 'Sal', we: 'Ãar', th: 'Per', fr: 'Cum', sa: 'Cmt' },
        //     monthLabels: {
        //         1: 'Oca',
        //         2: 'Åub',
        //         3: 'Mar',
        //         4: 'Nis',
        //         5: 'May',
        //         6: 'Haz',
        //         7: 'Tem',
        //         8: 'AÄu',
        //         9: 'Eyl',
        //         10: 'Eki',
        //         11: 'Kas',
        //         12: 'Ara'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // 'pt-br': {
        //     dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Fev',
        //         3: 'Mar',
        //         4: 'Abr',
        //         5: 'Mai',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Ago',
        //         9: 'Set',
        //         10: 'Out',
        //         11: 'Nov',
        //         12: 'Dez'
        //     },
        //     dateFormat: 'dd/mm/yyyy',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // de: {
        //     dayLabels: { su: 'So', mo: 'Mo', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'MÃ¤r',
        //         4: 'Apr',
        //         5: 'Mai',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dez'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // 'de-ch': {
        //     dayLabels: { su: 'So', mo: 'Mo', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'MÃ¤r',
        //         4: 'Apr',
        //         5: 'Mai',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dez'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // it: {
        //     dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Gio', fr: 'Ven', sa: 'Sab' },
        //     monthLabels: {
        //         1: 'Gen',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Mag',
        //         6: 'Giu',
        //         7: 'Lug',
        //         8: 'Ago',
        //         9: 'Set',
        //         10: 'Ott',
        //         11: 'Nov',
        //         12: 'Dic'
        //     },
        //     dateFormat: 'dd/mm/yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // 'it-ch': {
        //     dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Gio', fr: 'Ven', sa: 'Sab' },
        //     monthLabels: {
        //         1: 'Gen',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Mag',
        //         6: 'Giu',
        //         7: 'Lug',
        //         8: 'Ago',
        //         9: 'Set',
        //         10: 'Ott',
        //         11: 'Nov',
        //         12: 'Dic'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // pl: {
        //     dayLabels: { su: 'Nie', mo: 'Pon', tu: 'Wto', we: 'Åro', th: 'Czw', fr: 'PiÄ', sa: 'Sob' },
        //     monthLabels: {
        //         1: 'Sty',
        //         2: 'Lut',
        //         3: 'Mar',
        //         4: 'Kwi',
        //         5: 'Maj',
        //         6: 'Cze',
        //         7: 'Lip',
        //         8: 'Sie',
        //         9: 'Wrz',
        //         10: 'PaÅº',
        //         11: 'Lis',
        //         12: 'Gru'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // my: {
        //     dayLabels: {
        //         su: 'ááááºá¹ááá½á±',
        //         mo: 'ááááºá¹áá¬',
        //         tu: 'á¡ááºá¹áá«',
        //         we: 'áá¯áá¹ááá°á¸',
        //         th: 'áá¼áááá±á¸',
        //         fr: 'áá±á¬áá¼á¬',
        //         sa: 'ááá±'
        //     },
        //     monthLabels: {
        //         1: 'áááºááá«áá®',
        //         2: 'áá±áá±á¬áºáá«áá®',
        //         3: 'áááº',
        //         4: 'á§áá¼á®',
        //         5: 'áá±',
        //         6: 'áá½ááº',
        //         7: 'áá°áá­á¯ááº',
        //         8: 'á©áá¯ááº',
        //         9: 'áááºáááºáá¬',
        //         10: 'á¡á±á¬ááºáá­á¯áá¬',
        //         11: 'áá­á¯áááºáá¬',
        //         12: 'áá®áááºáá¬'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // sk: {
        //     dayLabels: { su: 'Ne', mo: 'Po', tu: 'Ut', we: 'St', th: 'Å t', fr: 'Pi', sa: 'So' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'MÃ¡j',
        //         6: 'JÃºn',
        //         7: 'JÃºl',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // sl: {
        //     dayLabels: { su: 'Ned', mo: 'Pon', tu: 'Tor', we: 'Sre', th: 'Äet', fr: 'Pet', sa: 'Sob' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Maj',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Avg',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'dd. mm. yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // ro: {
        //     dayLabels: { su: 'du', mo: 'lu', tu: 'ma', we: 'mi', th: 'jo', fr: 'vi', sa: 'sa' },
        //     monthLabels: {
        //         1: 'ian',
        //         2: 'feb',
        //         3: 'mart',
        //         4: 'apr',
        //         5: 'mai',
        //         6: 'iun',
        //         7: 'iul',
        //         8: 'aug',
        //         9: 'sept',
        //         10: 'oct',
        //         11: 'nov',
        //         12: 'dec'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // ca: {
        //     dayLabels: { su: 'dg', mo: 'dl', tu: 'dt', we: 'dc', th: 'dj', fr: 'dv', sa: 'ds' },
        //     monthLabels: {
        //         1: 'Gen',
        //         2: 'Febr',
        //         3: 'MarÃ§',
        //         4: 'Abr',
        //         5: 'Maig',
        //         6: 'Juny',
        //         7: 'Jul',
        //         8: 'Ag',
        //         9: 'Set',
        //         10: 'Oct',
        //         11: 'Nov',
        //         12: 'Des'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // id: {
        //     dayLabels: { su: 'Min', mo: 'Sen', tu: 'Sel', we: 'Rab', th: 'Kam', fr: 'Jum', sa: 'Sab' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Mei',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Ags',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Des'
        //     },
        //     dateFormat: 'dd-mm-yyyy',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // 'en-au': {
        //     dayLabels: { su: 'Sun', mo: 'Mon', tu: 'Tue', we: 'Wed', th: 'Thu', fr: 'Fri', sa: 'Sat' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'May',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Oct',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'dd/mm/yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // 'am-et': {
        //     dayLabels: { su: 'á¥ááµ', mo: 'á°á', tu: 'áá­á°á', we: 'á¨á¡á', th: 'áááµ', fr: 'áá­á¥', sa: 'áá³á' },
        //     monthLabels: {
        //         1: 'ááá©',
        //         2: 'áá¥á©',
        //         3: 'áá­á½',
        //         4: 'á¤áá¨',
        //         5: 'áá­',
        //         6: 'áá',
        //         7: 'ááá­',
        //         8: 'á¦ááµ',
        //         9: 'á´áá´',
        //         10: 'á¦á­á°',
        //         11: 'áá¬á',
        //         12: 'á²á´á'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // cs: {
        //     dayLabels: { su: 'Ne', mo: 'Po', tu: 'Ãt', we: 'St', th: 'Ät', fr: 'PÃ¡', sa: 'So' },
        //     monthLabels: {
        //         1: 'Led',
        //         2: 'Ãno',
        //         3: 'BÅe',
        //         4: 'Dub',
        //         5: 'KvÄ',
        //         6: 'Ävn',
        //         7: 'Ävc',
        //         8: 'Srp',
        //         9: 'ZÃ¡Å',
        //         10: 'ÅÃ­j',
        //         11: 'Lis',
        //         12: 'Pro'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // el: {
        //     dayLabels: { su: 'ÎÏÏ', mo: 'ÎÎµÏ', tu: 'Î¤ÏÎ¹', we: 'Î¤ÎµÏ', th: 'Î ÎµÎ¼', fr: 'Î Î±Ï', sa: 'Î£Î±Î²' },
        //     monthLabels: {
        //         1: 'ÎÎ±Î½',
        //         2: 'Î¦ÎµÎ²',
        //         3: 'ÎÎ±Ï',
        //         4: 'ÎÏÏ',
        //         5: 'ÎÎ±Î¹',
        //         6: 'ÎÎ¿ÏÎ½',
        //         7: 'ÎÎ¿ÏÎ»',
        //         8: 'ÎÏÎ³',
        //         9: 'Î£ÎµÏ',
        //         10: 'ÎÎºÏ',
        //         11: 'ÎÎ¿Îµ',
        //         12: 'ÎÎµÎº'
        //     },
        //     dateFormat: 'dd/mm/yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // kk: {
        //     dayLabels: { su: 'ÐÐº', mo: 'ÐÑ', tu: 'Ð¡Ñ', we: 'Ð¡Ñ', th: 'ÐÑ', fr: 'ÐÐ¼', sa: 'Ð¡Ð±' },
        //     monthLabels: {
        //         1: 'ÒÐ°Ò£',
        //         2: 'ÐÒÐ¿',
        //         3: 'ÐÐ°Ñ',
        //         4: 'Ð¡ÓÑ',
        //         5: 'ÐÐ°Ð¼',
        //         6: 'ÐÐ°Ñ',
        //         7: 'Ð¨ÑÐ»',
        //         8: 'Ð¢Ð°Ð¼',
        //         9: 'ÒÑÑÐº',
        //         10: 'ÒÐ°Ð·',
        //         11: 'ÒÐ°Ñ',
        //         12: 'ÐÐµÐ»Ñ'
        //     },
        //     dateFormat: 'dd-mmm-yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // th: {
        //     dayLabels: { su: 'à¸­à¸²', mo: 'à¸', tu: 'à¸­', we: 'à¸', th: 'à¸à¸¤', fr: 'à¸¨', sa: 'à¸ª' },
        //     monthLabels: {
        //         1: 'à¸¡.à¸',
        //         2: 'à¸.à¸.',
        //         3: 'à¸¡à¸µ.à¸.',
        //         4: 'à¹à¸¡.à¸¢.',
        //         5: 'à¸.à¸.',
        //         6: 'à¸¡à¸´.à¸¢.',
        //         7: 'à¸.à¸.',
        //         8: 'à¸ª.à¸.',
        //         9: 'à¸.à¸¢.',
        //         10: 'à¸.à¸.',
        //         11: 'à¸.à¸¢.',
        //         12: 'à¸.à¸.'
        //     },
        //     dateFormat: 'dd-mm-yyyy',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // 'ko-kr': {
        //     dayLabels: { su: 'ì¼', mo: 'ì', tu: 'í', we: 'ì', th: 'ëª©', fr: 'ê¸', sa: 'í ' },
        //     monthLabels: {
        //         1: '1ì',
        //         2: '2ì',
        //         3: '3ì',
        //         4: '4ì',
        //         5: '5ì',
        //         6: '6ì',
        //         7: '7ì',
        //         8: '8ì',
        //         9: '9ì',
        //         10: '10ì',
        //         11: '11ì',
        //         12: '12ì'
        //     },
        //     dateFormat: 'yyyy mm dd',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // da: {
        //     dayLabels: { su: 'SÃ¸n', mo: 'Man', tu: 'Tir', we: 'Ons', th: 'Tor', fr: 'Fre', sa: 'LÃ¸r' },
        //     monthLabels: {
        //         1: 'Jan',
        //         2: 'Feb',
        //         3: 'Mar',
        //         4: 'Apr',
        //         5: 'Maj',
        //         6: 'Jun',
        //         7: 'Jul',
        //         8: 'Aug',
        //         9: 'Sep',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'dd-mm-yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // lt: {
        //     dayLabels: { su: 'Sk', mo: 'Pr', tu: 'An', we: 'Tr', th: 'Kt', fr: 'Pn', sa: 'Å t' },
        //     monthLabels: {
        //         1: 'Saus.',
        //         2: 'Vas.',
        //         3: 'Kov.',
        //         4: 'Bal.',
        //         5: 'Geg.',
        //         6: 'BirÅ¾.',
        //         7: 'Liep.',
        //         8: 'Rugp.',
        //         9: 'Rugs.',
        //         10: 'Sapl.',
        //         11: 'Lapkr.',
        //         12: 'Gruod.'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // vi: {
        //     dayLabels: { su: 'CN', mo: 'T2', tu: 'T3', we: 'T4', th: 'T5', fr: 'T6', sa: 'T7' },
        //     monthLabels: {
        //         1: 'THG 1',
        //         2: 'THG 2',
        //         3: 'THG 3',
        //         4: 'THG 4',
        //         5: 'THG 5',
        //         6: 'THG 6',
        //         7: 'THG 7',
        //         8: 'THG 8',
        //         9: 'THG 9',
        //         10: 'THG 10',
        //         11: 'THG 11',
        //         12: 'THG 12'
        //     },
        //     dateFormat: 'dd/mm/yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // bn: {
        //     dayLabels: { su: 'à¦°à¦¬à¦¿', mo: 'à¦¸à§à¦®', tu: 'à¦®à¦à§à¦à¦²', we: 'à¦¬à§à¦§', th: 'à¦¬à§à¦¹à¦', fr: 'à¦¶à§à¦à§à¦°', sa: 'à¦¶à¦¨à¦¿' },
        //     monthLabels: {
        //         1: 'à¦à¦¾à¦¨à§',
        //         2: 'à¦«à§à¦¬à§à¦°à§',
        //         3: 'à¦®à¦¾à¦°à§à¦',
        //         4: 'à¦à¦ªà§à¦°à¦¿à¦²',
        //         5: 'à¦®à§',
        //         6: 'à¦à§à¦¨',
        //         7: 'à¦à§à¦²à¦¾à¦',
        //         8: 'à¦à¦à¦¸à§à¦',
        //         9: 'à¦¸à§à¦ªà§à¦à§',
        //         10: 'à¦à¦à§à¦à§',
        //         11: 'à¦¨à¦­à§',
        //         12: 'à¦¡à¦¿à¦¸à§'
        //     },
        //     dateFormat: 'dd-mm-yyyy',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // bg: {
        //     dayLabels: { su: 'Ð½Ð´', mo: 'Ð¿Ð½', tu: 'Ð²Ñ', we: 'ÑÑ', th: 'ÑÑ', fr: 'Ð¿Ñ', sa: 'ÑÐ±' },
        //     monthLabels: {
        //         1: 'ÑÐ½Ñ.',
        //         2: 'ÑÐµÐ².',
        //         3: 'Ð¼Ð°ÑÑ',
        //         4: 'Ð°Ð¿Ñ.',
        //         5: 'Ð¼Ð°Ð¹',
        //         6: 'ÑÐ½Ð¸',
        //         7: 'ÑÐ»Ð¸',
        //         8: 'Ð°Ð²Ð³.',
        //         9: 'ÑÐµÐ¿.',
        //         10: 'Ð¾ÐºÑ.',
        //         11: 'Ð½Ð¾Ðµ.',
        //         12: 'Ð´ÐµÐº.'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // hr: {
        //     dayLabels: { su: 'Ne', mo: 'Po', tu: 'Ul', we: 'Sr', th: 'Äe', fr: 'Pe', sa: 'Su' },
        //     monthLabels: {
        //         1: 'Sij',
        //         2: 'Vel',
        //         3: 'OÅ¾u',
        //         4: 'Tra',
        //         5: 'Svi',
        //         6: 'Lip',
        //         7: 'Srp',
        //         8: 'Kol',
        //         9: 'Ruj',
        //         10: 'Lis',
        //         11: 'Stu',
        //         12: 'Pro'
        //     },
        //     dateFormat: 'dd.mm.yyyy.',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // ar: {
        //     dayLabels: {
        //         su: 'Ø§ÙØ£Ø­Ø¯',
        //         mo: 'Ø§ÙØ§Ø«ÙÙÙ',
        //         tu: 'Ø§ÙØ«ÙØ§Ø«Ø§Ø¡',
        //         we: 'Ø§ÙØ§Ø±Ø¨Ø¹Ø§Ø¡',
        //         th: 'Ø§ÙØ®ÙÙØ³',
        //         fr: 'Ø§ÙØ¬ÙØ¹Ø©',
        //         sa: 'Ø§ÙØ³Ø¨Øª'
        //     },
        //     monthLabels: {
        //         1: 'ÙÙØ§ÙØ±',
        //         2: 'ÙØ¨Ø±Ø§ÙØ±',
        //         3: 'ÙØ§Ø±Ø³',
        //         4: 'Ø§Ø¨Ø±ÙÙ',
        //         5: 'ÙØ§ÙÙ',
        //         6: 'ÙÙÙÙÙ',
        //         7: 'ÙÙÙÙÙ',
        //         8: 'Ø£ØºØ³Ø·Ø³',
        //         9: 'Ø³Ø¨ØªÙØ¨Ø±',
        //         10: 'Ø£ÙØªÙØ¨Ø±',
        //         11: 'ÙÙÙÙØ¨Ø±',
        //         12: 'Ø¯ÙØ³ÙØ¨Ø±'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'sa',
        //     sunHighlight: false
        // },
        // is: {
        //     dayLabels: { su: 'sun', mo: 'mÃ¡n', tu: 'Ã¾ri', we: 'miÃ°', th: 'fim', fr: 'fÃ¶s', sa: 'lau' },
        //     monthLabels: {
        //         1: 'jan',
        //         2: 'feb',
        //         3: 'mar',
        //         4: 'apr',
        //         5: 'maÃ­',
        //         6: 'jÃºn',
        //         7: 'jÃºl',
        //         8: 'Ã¡gÃº',
        //         9: 'sep',
        //         10: 'okt',
        //         11: 'nÃ³v',
        //         12: 'des'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'su',
        //     sunHighlight: false
        // },
        // tw: {
        //     dayLabels: { su: 'é±æ¥', mo: 'é±ä¸', tu: 'é±äº', we: 'é±ä¸', th: 'é±å', fr: 'é±äº', sa: 'é±å­' },
        //     monthLabels: {
        //         1: 'ä¸æ',
        //         2: 'äºæ',
        //         3: 'ä¸æ',
        //         4: 'åæ',
        //         5: 'äºæ',
        //         6: 'å­æ',
        //         7: 'ä¸æ',
        //         8: 'å«æ',
        //         9: 'ä¹æ',
        //         10: 'åæ',
        //         11: 'åä¸æ',
        //         12: 'åäºæ'
        //     },
        //     dateFormat: 'yyyy-mm-dd',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // lv: {
        //     dayLabels: { su: 'S', mo: 'P', tu: 'O', we: 'T', th: 'C', fr: 'P', sa: 'S' },
        //     monthLabels: {
        //         1: 'Janv',
        //         2: 'Febr',
        //         3: 'Marts',
        //         4: 'Apr',
        //         5: 'Maijs',
        //         6: 'JÅ«n',
        //         7: 'JÅ«l',
        //         8: 'Aug',
        //         9: 'Sept',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dec'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // },
        // et: {
        //     dayLabels: { su: 'P', mo: 'E', tu: 'T', we: 'K', th: 'N', fr: 'R', sa: 'L' },
        //     monthLabels: {
        //         1: 'Jaan',
        //         2: 'Veebr',
        //         3: 'MÃ¤rts',
        //         4: 'Apr',
        //         5: 'Mai',
        //         6: 'Juuni',
        //         7: 'Juuli',
        //         8: 'Aug',
        //         9: 'Sept',
        //         10: 'Okt',
        //         11: 'Nov',
        //         12: 'Dets'
        //     },
        //     dateFormat: 'dd.mm.yyyy',
        //     firstDayOfWeek: 'mo',
        //     sunHighlight: false
        // }
    };

    getLocaleOptions(locale: string): IMyOptions {
        if (locale && this.locales.hasOwnProperty(locale)) {
            // User given locale
            return this.locales[locale];
        }
        // Default: en
        return this.locales[DEFAULT_LOCALE];
    }
}
